<template>
  <div>
    <!-- <div class="l-home__navbar">
            <img src="static/tempAssets/linkem-logo-home.png" alt="" class="l-home__navbar__logo">
        </div> -->
    <section class="l-home">
      <div
        class="locale-changer"
        v-if="this.$store.state.campaign.accept_languages.length > 1"
      >
        <div class="l-home__locale__wrapper">
          <div
            class="l-home__navbar__locale primary-bg"
            @click="localeOpen = !localeOpen"
          >
            <span class="l-home__navbar__locale__text">{{
              locale.toUpperCase()
            }}</span>
            <i
              class="fas fa-chevron-down l-home__navbar__locale__icon"
              :class="{ localeOpen: !localeOpen }"
            ></i>
          </div>
          <div
            class="l-home__navbar__locale--expanded"
            :class="{
              'd-none l-home__navbar__locale--expanded': !localeOpen
            }"
          >
            <div
              class="l-home__dropdown__item"
              v-for="lang in locales"
              :key="lang"
              @click="handleChangeLocale(lang)"
            >
              {{ lang.toUpperCase() }}
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="col-12 col-lg-7">
          <div class="l-home__content">
            <img
              src="static/tempAssets/logo-gray.svg"
              alt=""
              class="l-home__navbar__logo"
            />
            <h1 class="l-home__title">
              {{ $t("MAKE ENGAGEMENT AND LOYALTY REAL") }}
            </h1>
            <h2 class="l-home__subtitle">
              {{
                $t(
                  "Prova le funzionalità della demo di Fanize, la piattaforma di engagement e loyalty che ti permetterà di acquisire, profilare e coinvolgere i tuoi utenti con missioni e giochi personalizzabili"
                )
              }}
            </h2>
            <div class="l-home__buttons_container">
              <template
                v-for="touchpoint in $store.state.campaign.identity_touchpoints"
              >
                <template v-if="touchpoint.provider == 'google'">
                  <button
                    @click="getSocialLoginLink(touchpoint.provider)"
                    v-bind:key="touchpoint.provider"
                    class="btn btn-google icon-left l-home__button"
                  >
                    <div
                      v-bind:key="touchpoint.provider"
                      v-html="icons.google"
                      class="google-logo"
                      style="display:inline-block; width:24px"
                    ></div>
                    Google
                  </button>
                </template>
                <template v-else>
                  <social-button
                    @click="getSocialLoginLink(touchpoint.provider)"
                    v-bind:key="touchpoint.provider"
                    :iconClass="touchpoint.presenter.icon.class"
                    :buttonClass="
                      touchpoint.presenter.class + ' l-home__button'
                    "
                    :providerLabel="touchpoint.presenter.label"
                  ></social-button>
                </template>
              </template>
              <div
                v-if="
                  Object.keys($store.state.campaign.identity_touchpoints)
                    .length > 0
                "
                class="or-separator l-home__separator"
              >
                {{ $t("oppure accedi con") }}
              </div>
              <button
                class="btn btn-primary icon-left l-home__button"
                style="height: auto;"
                @click="$router.push({ name: 'login' })"
              >
                <template
                  ><i class="fas fa-sign-in"></i>
                  {{ $t("Email / Cellulare") }}</template
                >
              </button>
            </div>
            <!-- <div class="l-home__login__container">
                                    <h1 class="l-home__login__title">{{$t('Inserisci le credenziali dell’Area Clienti MyLinkem')}}</h1>
                                    <div class="l-home__login__wrapper">
                                        <input type="text" id="l-home__login__input" v-model="login.credential">
                                        <label for="l-home__login__input" :class="[login.credential ? 'isActive' : '']">Username</label>
                                    </div>
                                    <div class="l-home__login__wrapper">
                                        <input type="password" id="l-home__login__input" v-model="login.password">
                                        <label for="l-home__login__input" :class="[login.password ? 'isActive' : '']">Password</label>
                                    </div>
                                    <button class="btn login-button" @click="signin()">Accedi</button>
                                    <h1 class="l-home__login__title">Hai dimenticato le credenziali MyLinkem?<br><a href="https://mylinkempage.linkem.com/User/ResetPassword?returnUrl=%2F%3Flevel%3Dprivati" target="_blank"><b> Clicca qui.</b></a></h1>
                            </div> -->
          </div>
        </div>
      </div>
    </section>
    <BoxContainer></BoxContainer>
    <div class="l-home__container">
      <CarouselContainer :catalog="homeData.catalog"></CarouselContainer>
      <MissionContainer :actions="homeData.actions"></MissionContainer>
      <section class="l-home__banner__section">
        <div class="container">
          <div class="l-home__banner__wrapper">
            <span>
              {{
                $t(
                  "Questa istanza rappresenta una versione dimostrativa di Fanize."
                )
              }}
              <br />
              {{ $t("Per maggiori informazioni consulta il sito") }}
              <b>www.fanize.it</b> o {{ $t("contattaci alla mail") }}
              <b>fanize@iquii.com</b>
            </span>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import parseDomain from "parse-domain";
import _ from "lodash";
import SocialButton from "../Campaign/SocialButton";
import BoxContainer from "./BoxContainer";
import CarouselContainer from "./CarouselContainer";
import MissionContainer from "./MissionContainer";
import iconGoogle from "../../assets/svg/google_G_logo.svg";
import { getLocale, changeLocale } from "@/i18n.js";

export default {
  data() {
    return {
      icons: {
        google: iconGoogle,
        garmin: "iconGarminConnect"
      },
      appleButton: "appleButton",
      homeData: {},
      login: {
        credential: "",
        password: ""
      },
      locale: getLocale(),
      locales: this.generateLocales(),
      localeOpen: false
    };
  },
  beforeCreate() {
    this.$http
      .get(
        "/api/v1/campaigns/" + this.$store.state.campaign.id + "/home/settings"
      )
      .then(response => {
        this.homeData = response.data.data;
      });
  },
  created() {
    const parsedDomain = parseDomain(window.location.hostname);
    if (this.$route.query.ref !== undefined) {
      Cookies.set("mgm", this.$route.query.ref, {
        expires: 1,
        domain: "." + parsedDomain.domain + "." + parsedDomain.tld
      });
    }

    if (this.$route.query.mgm_code !== undefined) {
      Cookies.set("mgm_code", this.$route.query.mgm_code, {
        expires: 1,
        domain: "." + parsedDomain.domain + "." + parsedDomain.tld
      });
    }
  },
  methods: {
    getSocialLoginLink(provider) {
      this.$http
        .get(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/" +
            provider +
            "/socialLoginUrl"
        )
        .then(response => {
          const parsedDomain = parseDomain(window.location.hostname);
          if (response.data.data.url && parseDomain) {
            Cookies.set("fanize_social_fallback", window.location.hostname, {
              domain: "." + parsedDomain.domain + "." + parsedDomain.tld
            });
            window.location = response.data.data.url;
          }
        });
    },
    async appleLogin() {
      const response = await this.$http.get(
        "/api/v1/campaigns/" +
          this.$store.state.campaign.id +
          "/users/apple/web/login"
      );
      const parsedDomain = parseDomain(window.location.hostname);
      Cookies.set("fanize_social_fallback", window.location.hostname, {
        domain: "." + parsedDomain.domain + "." + parsedDomain.tld
      });
      Cookies.set("fanize_apple_campaign_id", this.$store.state.campaign.id, {
        domain: "." + parsedDomain.domain + "." + parsedDomain.tld
      });
      Cookies.set("fanize_apple_state", _.get(response, "data.data.uuid"), {
        domain: "." + parsedDomain.domain + "." + parsedDomain.tld
      });

      window.location = _.get(response, "data.data.url");
    },
    signin() {
      this.$store.commit("showSpinner");
      this.$http
        .post(
          "/api/v1/campaigns/" + this.$store.state.campaign.id + "/users/login",
          this.login
        )
        .then(response => {
          localStorage.setItem("token", response.data.data.token.access_token);
          this.$store.state.authorization.access_token =
            response.data.data.token.access_token;
          this.$http.defaults.headers.common["Authorization"] =
            "Bearer " + response.data.data.token.access_token;
          this.$http.defaults.headers["Authorization"] =
            "Bearer " + response.data.data.token.access_token;
          this.$store.state.authorization.expires_in =
            response.data.data.token.expires_in;
          this.$store.commit("hideSpinner");
          this.$store.dispatch("getUserInfo").then(response => {
            this.pushDeviceInfo();
            this.$router.push({ name: "dashboard" });
          });
        })
        .catch(error => {
          let errorResponse = error.response;
          switch (errorResponse.status) {
            case 422:
            case 404:
              this.$store.commit("pushMessage", {
                type: "waiting",
                title: this.$i18n.t("Le credenziali non sono valide"),
                text: this.$i18n.t(
                  "Prova ad inserire nuovamente le credenziali Test corrette o segui la procedura di recupero"
                )
              });
              break;
            case 406:
              if (this.$store.state.brand.idm_external_verify) {
                this.$store.commit("pushMessage", {
                  type: "waiting",
                  title: this.$i18n.t("Aspetta!"),
                  text: this.$i18n.t(
                    "Controlla la tua mail per verificare il tuo account"
                  )
                });
              } else {
                this.currentDisplayIfNotDesktop = "confirmation";
                this.showConfirmation = true;
                this.confirmationUserId = errorResponse.data.meta.userId;
                this.confirmationType =
                  errorResponse.data.meta.confirmationType;
                this.confirmationAddress =
                  errorResponse.data.meta.confirmationAddress;
              }
              break;
            case 401:
              this.$store.commit("pushMessage", {
                type: "waiting",
                title: this.$i18n.t("Password non valida"),
                text: this.$i18n.t("Riprovare per favore")
              });
              break;
            default:
              this.$store.commit("pushMessage", {
                type: "waiting",
                title: this.$i18n.t("Error")
              });
          }
          this.$store.commit("hideSpinner");
        });
    },
    generateLocales() {
      const activeLocale = getLocale();
      this.locale = activeLocale;
      const locales = this.$store.state.campaign.accept_languages;
      return locales.filter(item => item != activeLocale);
    },
    async handleChangeLocale(locale) {
      this.locale = locale;
      const locales = this.$store.state.campaign.accept_languages;
      this.locales = locales.filter(item => item != locale);
      this.localeOpen = !this.localeOpen;
      await changeLocale(locale);
    }
  },
  computed: {
    coverImage() {
      return this.$store.state.campaign.image;
    }
  },
  components: {
    SocialButton,
    BoxContainer,
    MissionContainer,
    CarouselContainer
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/mixins";

.l-home {
  background: url("/static/tempAssets/hero-background.png") no-repeat right
    center;
  background-size: cover;
  @include xl {
    min-height: 110vh;
  }
}

@media (max-width: 768px) {
  .l-home {
    background: url("/static/tempAssets/hero-background.png") no-repeat left
      center;
    background-size: cover;
  }
}

.l-home__navbar {
  display: flex;
  justify-content: center;
  align-items: center;
}
.l-home__navbar__logo {
  margin: 1rem 0;
  width: 40%;
}
.l-home__content {
  display: flex;
  flex-direction: column;
  color: white;
  align-items: center;
  text-align: center;
  margin-bottom: 2rem;
  padding-top: 3rem;
  @include md {
    align-items: flex-start;
    text-align: left;
  }
}
.l-home__title {
  font-style: 36px;
  @include lg {
    font-size: 46px;
  }
  font-weight: 600;
}
.l-home__subtitle {
  font-size: 20px;
  @include lg {
    font-size: 26px;
    max-width: 80%;
  }
}
.l-home__container {
  background: url("/static/tempAssets/background-mission.png") no-repeat right;
  background-size: cover;
  background-position: right;
  padding-top: 4rem;
  @include lg {
    background: url("/static/tempAssets/background-mission.png") no-repeat;
    background-position: center;
    background-size: cover;
  }
}
.l-home__buttons_container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  margin: 2rem 0;
  @include md {
    max-width: 50%;
  }
}
.l-home__button {
  display: block;
  width: 100%;
  margin-bottom: 0.7rem;
  height: 50px;
  line-height: 43px;
  font-weight: 300;
  box-shadow: 0px 10px 40px -6px rgba(0, 0, 0, 0.1);
}

.l-home__button__icon {
  width: 14%;
}
.l-home__separator {
  margin: 1rem 0;
}

.l-home__login__container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem 0;
  margin: 2rem 0;
  background-color: white;
  border-radius: 10px;
  @include md {
    width: 57%;
  }
}
.l-home__login__title {
  color: black;
  font-size: 18px;
  margin-top: 1rem;
  text-align: center;
  width: 70%;
  a {
    font-size: 14px;
    color: black;
  }
}

.l-home__login__wrapper {
  position: relative;
  border-radius: 80px;
  margin: 0.5rem;
  width: 200px;
  &:focus-within {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16);
  }
  @include md {
    width: 250px;
  }
}

label {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  transition: 0.25s;
  left: 1rem;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
  padding: 0.25rem;
  background: #fff;
  color: lightgray;
}

input {
  border: 2px solid lightgray;
  padding: 1rem;
  border-radius: 35px;
  width: 100%;
  &:focus {
    border: 2px solid #ee5340;
    outline: 0;
  }
  &:focus ~ label {
    top: 4px;
    transition: 0.25s;
    font-size: 12px;
    color: #ee5340;
  }
}

label.isActive {
  top: 4px;
  transition: 0.25s;
  font-size: 12px;
  color: black;
}

.btn.login-button {
  // border : 2px solid #1e6bb1;
  background-color: #ee5340;
  width: 50%;
  color: white;
  border-radius: 45px;
  padding: 10px;
  cursor: pointer;
  margin: 0.5rem;
}
.btn.login-button:hover {
  // border : 2px solid #ee5340;
  background-color: #ee5340;
  color: white;
}
.nb-spinner {
  width: 75px;
  height: 75px;
  margin: 0;
  background: transparent;
  border-top: 4px solid #009688;
  border-right: 4px solid transparent;
  border-radius: 50%;
  -webkit-animation: 1s spin linear infinite;
  animation: 1s spin linear infinite;
}

.l-home__banner__section {
  background-color: white;
  color: #6101e9;
}
.l-home__banner__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #6101e9;
  padding: 1rem;

  h1 {
    width: 100%;
    font-size: 35px;
    font-weight: bold;
  }
  h2 {
    width: 100%;
    font-size: 25px;
  }
}

.c-missioncontainer__register__button {
  margin: 2rem 0;
  @include lg {
    max-width: 40%;
  }
}
.btn.register-button {
  border: 2px solid white;
  background-color: white;
  color: #ee5340;
  border-radius: 45px;
  padding: 18px 58px 18px 58px;
  cursor: pointer;
}
.btn.register-button:hover {
  border: 2px solid #ea8a6e;
  background-color: #ea8a6e;
  color: white;
}
.locale-changer {
  position: absolute;
  top: 40px;
  right: 40px;
  z-index: 9999;
}
.l-home__navbar__locale {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-right: 1rem;
  padding: 0rem 1rem;
  border-radius: 25px;
  // background-color: #ff276f;
  color: white;
  width: 4rem;
  margin-bottom: 0.3rem;
  cursor: pointer;
  position: relative;
}
.l-home__navbar__locale__text {
  margin-right: 0.3rem;
}
.l-home__navbar__locale__icon {
  transition: transform 0.3s;
  transform: rotate(180deg);
}
.l-home__locale__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.l-home__navbar__locale--expanded {
  transition: height 0.5 transform 0.5s;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 30px;
}
.localeOpen {
  transition: transform 0.3s;
  transform: rotate(360deg);
}
.l-home__dropdown__item {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-right: 1rem;
  padding: 0rem 1rem;
  border-radius: 25px;
  background-color: rgba(255, 255, 255, 0.8);
  color: black;
  width: 4rem;
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
}
.l-home__dropdown__item:hover {
  background-color: white;
}
</style>
